import { render, staticRenderFns } from "./home_download.vue?vue&type=template&id=d5f72f1e&scoped=true"
import script from "./home_download.vue?vue&type=script&lang=js"
export * from "./home_download.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f72f1e",
  null
  
)

export default component.exports